/* eslint-disable react/prefer-stateless-function,no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import { t } from 'utils/translates';
import {
  changeFieldGeoTargetChangeTypeComparison,
  changeFieldGeoTargetToggleItem
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import { selectFieldGeoTarget } from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';

import {
  selectItemsIds,
  selectItemById,
  selectRequestState,
  sendRequest
} from 'mt-react-common/common/reducers/list/reducer';

import MediumPreLoader from '../../../../Common/PreLoaders/MediumPreLoader';
import RegionsLayer from './RegionsLayer';

const countriesListRN = 'localeModule.lists.countriesList';

class CountriesLayer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (
      this.props.fieldGeoTarget.value.typeComparison !== null &&
      !this.props.countriesIds.length > 0
    ) {
      this.props.sendRequest();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.fieldGeoTarget.value.typeComparison !==
        this.props.fieldGeoTarget.value.typeComparison &&
      !this.props.countriesIds.length > 0
    ) {
      this.props.sendRequest();
    }
  }

  render() {
    let countriesFragment = null;
    if (this.props.countriesRequestState.inProgress) {
      countriesFragment = (
        <div>
          <MediumPreLoader />
        </div>
      );
    } else if (this.props.fieldGeoTarget.value.typeComparison !== null) {
      countriesFragment = this.props.countriesIds.map(itemId => {
        const item = this.props.selectItemById(itemId);
        const isChecked = Object.keys(
          this.props.fieldGeoTarget.value.countries
        ).includes(item.iso_code);
        const isCrossedOutClass =
          (this.props.fieldGeoTarget.value.typeComparison === '1' &&
            !isChecked) ||
          (this.props.fieldGeoTarget.value.typeComparison === '0' && isChecked);
        return (
          <div key={`geoTargetCountry${itemId}`}>
            <div
              key={`countryCheckbox${item.iso_code}`}
              className="checkbox abc-checkbox abc-checkbox-primary"
            >
              <input
                id={`country${item.iso_code}`}
                className="styled"
                type="checkbox"
                checked={isChecked}
                value={item.iso_code}
                onChange={() =>
                  this.props.changeFieldGeoTargetToggleCountry(item.iso_code)
                }
              />
              <label
                htmlFor={`country${item.iso_code}`}
                className={isCrossedOutClass ? 'crossed-out' : null}
              >
                {item.name}
              </label>
            </div>
            {isChecked ? (
              <RegionsLayer
                reducerName={this.props.reducerName}
                countryIsoCode={item.iso_code}
              />
            ) : null}
          </div>
        );
      });
    }
    return (
      <React.Fragment>
        <div className="form-group">
          <div className="control-group" id="geoTargetTypeComparison">
            <div className="radio abc-radio" data-target="#manual-check">
              <input
                defaultChecked={
                  this.props.fieldGeoTarget.value.typeComparison === null
                }
                onChange={() => this.props.changeCountriesTypeComparison(null)}
                id="geoTargetTypeComparisonNull"
                name="geoTargetTypeComparison"
                type="radio"
              />
              <label htmlFor="geoTargetTypeComparisonNull">
                <div className="text-strong m-b-4">
                  {t('Не использовать геотрагетинг')}
                </div>
                {t(
                  'Ваше задание смогут выполнять исполнители из любой географической локации'
                )}
              </label>
            </div>
            <div className="radio abc-radio" data-target="#auto-check">
              <input
                defaultChecked={
                  this.props.fieldGeoTarget.value.typeComparison === '1'
                }
                onChange={() => this.props.changeCountriesTypeComparison('1')}
                id="geoTargetTypeComparisonEnable"
                name="geoTargetTypeComparison"
                type="radio"
              />
              <label htmlFor="geoTargetTypeComparisonEnable">
                <div className="text-strong m-b-4">{t('Включить страны')}</div>
                {t('Ваше задание смогут выполнять исполнители выбранных стран')}
              </label>
            </div>
            <div className="radio abc-radio" data-target="#auto-check">
              <input
                defaultChecked={
                  this.props.fieldGeoTarget.value.typeComparison === '0'
                }
                onChange={() => this.props.changeCountriesTypeComparison('0')}
                id="geoTargetTypeComparisonExclude"
                name="geoTargetTypeComparison"
                type="radio"
              />
              <label htmlFor="geoTargetTypeComparisonExclude">
                <div className="text-strong m-b-4">{t('Исключить страны')}</div>
                {t(
                  'Ваше задание смогут выполнять исполнители из любой страны кроме выбранных'
                )}
              </label>
            </div>
          </div>
        </div>
        {countriesFragment}
      </React.Fragment>
    );
  }
}

CountriesLayer.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  reducerName: PropTypes.string.isRequired,

  fieldGeoTarget: PropTypes.shape({
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,

  changeCountriesTypeComparison: PropTypes.func.isRequired,
  changeFieldGeoTargetToggleCountry: PropTypes.func.isRequired,

  countriesIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  sendRequest: PropTypes.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  selectItemById: PropTypes.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  countriesRequestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired
  }).isRequired
};

const mapStateToProps = (state, props) => ({
  fieldGeoTarget: selectFieldGeoTarget(state, props.reducerName),
  countriesRequestState: selectRequestState(state, countriesListRN),
  countriesIds: selectItemsIds(state, countriesListRN),
  selectItemById: id => selectItemById(state, countriesListRN, id)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeCountriesTypeComparison: value =>
    dispatch(
      changeFieldGeoTargetChangeTypeComparison(
        props.reducerName,
        null,
        null,
        value
      )
    ),
  sendRequest: () => dispatch(sendRequest(countriesListRN)),
  changeFieldGeoTargetToggleCountry: countryIsoCode =>
    dispatch(changeFieldGeoTargetToggleItem(props.reducerName, countryIsoCode))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CountriesLayer);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/GeoTargetTaskInputs/CountriesLayer/CountriesLayer.js